import { showGlobalAlert } from "context/AlertContext";

const callApi = async (url, options, noJson) => {
	try {
		const response = await fetch(url, options);
		const data = noJson ? await response.text() : await response.json();

		if (data && data.error === 'INVALID_TOKEN') {
			window.dispatchEvent(new Event('logoutUser'));
			handleError(response, data);
			return null;
		}

		if (!response.ok) {
			handleError(response, data);
			return null;
		}

		return data;
	} catch (e) {
		console.error('catchError', e);
		showGlobalAlert(
			'¡Ups!',
			'No se ha podido obtener respuesta del servidor. Por favor, inténtalo de nuevo más tarde.'
		);
	}
};

const handleError = (response) => {
	console.log('handleError: ', response);
	showGlobalAlert(
		'¡Ups!',
		'No se ha podido obtener respuesta del servidor. Por favor, inténtalo de nuevo más tarde.'
	);
};

export const callApiPost = async (url, data) => {
	return await callApi(url, {
		method: 'POST',
		body: JSON.stringify(data),
		headers: getAuthHeaders(),
		credentials: 'include',
	});
};

export const callApiUpload = async (url, data) => {
	return await callApi(url, {
		method: 'POST',
		body: data,
		headers: getAuthHeaders(false),
		credentials: 'include',
	});
};

export const callApiGet = async (url) => {
	return await callApi(url, {
		method: 'GET',
		headers: getAuthHeaders(),
		credentials: 'include',
	});
};

const getAuthHeaders = (isJson = true) => {
	let headers = {};
	if (isJson) headers['Content-Type'] = 'application/json';
	const token = sessionStorage.getItem('authToken');
	if (token) headers['token'] = token;
	return headers;
};
